import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { SlideNav } from './SlideNav'
import { Header } from './Header';
import { Footer } from './Footer'
import ScrollToTopListener from '../utils/scrollToTop';
import MaintenanceChecker from '../utils/maintenanceChecker';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
        <div>
            <ScrollToTopListener />
            <MaintenanceChecker />
            <SlideNav />
            <Header pageWrapId={ 'root' }/>
        <Container >
          {this.props.children}
            </Container>
            <Footer />
      </div>
    );
  }
}
